export const categories = [
  { title: "Good", color: "#C8E6C9" },
  { title: "Bad", color: "#FFCDD2" },
  { title: "Ideas", color: "#B3E5FC" },
  { title: "Actions", color: "#FFF9C4" },
  { title: "Kudos", color: "#B2EBF2" },
];
